import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "edit-user-view d-flex"
}
const _hoisted_2 = { class: "pa-6 edit-user-form" }
const _hoisted_3 = { class: "d-flex form-row nickname-setting" }
const _hoisted_4 = { class: "d-flex form-row avatar-setting" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex form-row avatar-preview"
}
const _hoisted_6 = { class: "ml-6 mt-4" }

import {ref, onMounted} from 'vue'
import store from '@/store'
import {useApi} from "@/api/handler";
import {user} from "@/api";
import {ApiMap} from "@/api/type";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserView',
  setup(__props) {

const info = ref<ApiMap['/user/login']['resp'] | null>(null)

onMounted(() => {
  info.value = user.GetUserInfo()
})

const rules = {
  required: (v: string) => !!v || '不能为空',
  url: (v: string) =>
      !v || /^https?:\/\/.+/.test(v) || '请输入合法的链接地址',
}

function handleSubmitForm () {
  if (!info.value) return
  if (!info.value.nickname) {
    store.dispatch('snackBarModule/showError', '昵称不能为空')
    return
  }
  useUpdateUser()
  store.dispatch('snackBarModule/showSuccess', '更新成功')
}

const useUpdateUser = () => {
  if (!info.value) return
  useApi({
    api: user.UpdateUser({
      id: +info.value.id,
      nickname: info.value.nickname,
      avatar: info.value.avatar,
      username: info.value.username,
    }),
    onSuccess: () => {
      window.localStorage.removeItem('user')
      router.push('/login')
    },
    tip: '更改成功'
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (info.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-h5 font-weight-bold text-blue-lighten-2 ma-6" }, "修改用户信息", -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "px-8 mt-1 text-label" }, "昵称", -1)),
            _createVNode(_component_v_text_field, {
              modelValue: info.value.nickname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((info.value.nickname) = $event)),
              placeholder: "请输入昵称",
              variant: "outlined",
              density: "compact",
              rules: [rules.required]
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "px-8 mt-1 text-label" }, "头像链接", -1)),
            _createVNode(_component_v_text_field, {
              modelValue: info.value.avatar,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((info.value.avatar) = $event)),
              placeholder: "请输入头像图片链接",
              variant: "outlined",
              density: "compact",
              rules: [rules.url]
            }, null, 8, ["modelValue", "rules"])
          ]),
          (info.value.avatar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "px-8 mt-1 text-label" }, "头像预览", -1)),
                _createVNode(_component_v_avatar, { size: "64" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: info.value.avatar
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_btn, {
              block: "",
              color: "blue-lighten-1",
              height: "40px",
              onClick: handleSubmitForm
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("保存")
              ])),
              _: 1,
              __: [5]
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})